import Pages from "./pages/Pages"
import Category from "./components/Category";
import SearchBar from "./components/SearchBar";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { GiKnifeFork } from "react-icons/gi";

function App() {
  return (
    <>
      <Nav>
        <GiKnifeFork />
        <Logo to={"/"}>yummy</Logo>
      </Nav>
      <SearchBar />
      <Category />
      <Pages />
    </>
  );
}

const Logo = styled(Link)`
  text-decoration: none;
  font-size: 2.5rem;
  font-weight: 400;
  font-family: "Lobster Two", cursive;
`

const Nav = styled.nav`
  padding: 2rem 0rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  svg {
    font-size: 2rem;
  }

  @media (max-width: 840px) {
    justify-content: center;
  }
`

export default App;
